import { useEffect, useRef, useState } from 'react';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import { adminCountSupportTickets } from '../../../ticketing/services/adminTicketingFunctionsApi';

export function useSupportTicketCount(status = 'open', { pollMs = 120000 } = {}) {
  const { admin } = useAdminAuth();
  const getAdminIdTokenRef = useRef(null);

  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getAdminIdTokenRef.current = admin?.getIdToken;
  }, [admin?.getIdToken]);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      setError('');
      setLoading(true);
      try {
        const res = await adminCountSupportTickets({ status });
        if (!cancelled) setCount(Number(res?.count || 0));
      } catch (e) {
        console.error(e);
        if (!cancelled) setError('Failed to load ticket count.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();
    const t = setInterval(() => {
      if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return;
      run();
    }, pollMs);

    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, [status, pollMs]);

  return { count, loading, error };
}

